module.exports = __webpack_public_path__ + "media/how_fastweb_works/01_signup-9aa65016.jpg";